module.exports = __webpack_public_path__ + "static/media/g.2abdf3ce.svg";